<template>
  <div class="lg:flex lg:items-center lg:w-auto p-3">
    <div class="text-center flex items-center">
      <ProfileDropDown
        :user="user"
        :isPreview="isPreview"
        :baseUrl="baseUrl"
        :logout="logout"
        :profile="profile"
        :backPortalPage="backPortalPage"
        :isPortal="isPortal"
      />
    </div>
  </div>
</template>
<script>
import ProfileDropDown from './ProfileDropDown';
export default {
  name: 'NavbarProfileSettings',
  data() {
    return {
      baseUrl: 'test',
    };
  },
  props: [
    'user',
    'isPreview',
    'logout',
    'profile',
    'backPortalPage',
    'isPortal',
  ],
  components: { ProfileDropDown },
};
</script>
